import { TagVariant } from '@optimus-web/core';
import { PaymentCardState, PaymentMethod, SepaDirectDebitProviderState } from '@mews-commander/data-access';
import { createHandler } from '@mews/std';
import { PaymentMethodCommonValues } from './types';

export const getTagVariantFromPaymentMethodState = createHandler<PaymentMethodCommonValues['state'], TagVariant>({
    Enabled: 'primary',
    Disabled: 'warning',
    Expired: 'warning',
});

export const isPaymentCardPaymentMethod = (paymentMethod: PaymentMethod) => paymentMethod === PaymentMethod.PaymentCard;
export const isSepaPaymentMethod = (paymentMethod: PaymentMethod) => paymentMethod === PaymentMethod.SepaDirectDebit;
export const isSepaPaymentMethodState = (
    paymentMethod: PaymentMethod,
    state: PaymentCardState | SepaDirectDebitProviderState
): state is SepaDirectDebitProviderState => paymentMethod === PaymentMethod.SepaDirectDebit;
export const isCardPaymentMethodState = (
    paymentMethod: PaymentMethod,
    state: PaymentCardState | SepaDirectDebitProviderState
): state is PaymentCardState => paymentMethod === PaymentMethod.PaymentCard;
